import { render, staticRenderFns } from "./FinishedIndex.vue?vue&type=template&id=28970854&scoped=true&"
import script from "./FinishedIndex.vue?vue&type=script&lang=js&"
export * from "./FinishedIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28970854",
  null
  
)

export default component.exports